import { useEffect } from 'react';
import { tc } from '../../lib/trackingContext';

export type AuthLocation =
  | 'standard_login'
  | 'checkout'
  | 'convert_guest'
  | 'order_confirmation'
  | 'magic_link_confirmation';

type UseAuthMethodArgs = {
  authLocation?: AuthLocation;
};

export const useAuthMethod = ({ authLocation }: UseAuthMethodArgs = {}) => {
  useEffect(() => {
    tc.setCurrent('auth_method', 'passwordless');
    tc.setCurrent('auth_location', authLocation);

    return () => {
      tc.setCurrent('auth_method', undefined);
      tc.setCurrent('auth_location', undefined);
    };
  }, [authLocation]);
};
